(() => {
  'use strict';
  const hosts = ['strutt.us', 'strutt.inc', 'uk.strutt.inc', 'eu.strutt.inc',
    'gfhpc0-p9.myshopify.com', 'sy10cy-bd.myshopify.com', '321eeeus.myshopify.com'];
  const valid = value => typeof value === 'string' && /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value);
  // Remove credentials before analytics or other scripts can collect the URL.
  const incoming = new URL(location.href);
  let pending = new URLSearchParams(incoming.hash.slice(1));
  if (pending.get('_store_auth') === '1' || pending.get('_points_auth') === '1') {
    incoming.hash = pending.get('anchor') || '';
    history.replaceState(history.state, '', incoming.pathname + incoming.search + incoming.hash);
  } else {
    pending = null;
  }
  window.consumeStoreAuthHandoff = () => {
    const value = pending;
    pending = null;
    return value;
  };
  window.withStoreAuth = function (href) {
    const target = new URL(href, location.origin);
    if ((target.origin === location.origin && !pending) || target.protocol !== 'https:' || target.port ||
        !hosts.includes(target.hostname) || target.username || target.password) return target.href;
    const read = name => {
      const cookie = document.cookie.split(';').map(item => item.trim()).find(item => item.startsWith(name + '='));
      return cookie ? cookie.slice(name.length + 1) : '';
    };
    // Replace an earlier handoff instead of nesting credentials in the anchor.
    const previous = new URLSearchParams(target.hash.slice(1));
    const anchor = previous.get('_store_auth') === '1' || previous.get('_points_auth') === '1'
      ? previous.get('anchor') || '' : target.hash.slice(1);
    target.hash = anchor;
    const at = pending ? pending.get('at') : read('accessToken');
    const rt = pending ? pending.get('rt') : read('refreshToken');
    if (!valid(at) || !valid(rt)) return target.href;
    target.hash = new URLSearchParams({ _store_auth: '1', at, rt, anchor }).toString();
    return target.href;
  };
  // Capture before inline navigation handlers; also cover modified/middle clicks.
  const prepare = event => {
    const link = event.target.closest?.('.region-modal__list a[data-region]');
    if (link) link.href = window.withStoreAuth(link.href);
  };
  document.addEventListener('click', prepare, true);
  document.addEventListener('auxclick', prepare, true);
  document.addEventListener('contextmenu', prepare, true);
})();
